module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_02-05e34d4752e427a5d8b69a09612d6413.png";